var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.699
    },
    fill: "#fd8fa8",
    d: "M 39.5,1.5 C 37.4099,3.39022 35.0765,5.05689 32.5,6.5C 31.8165,6.13727 31.1499,5.80393 30.5,5.5C 31.463,4.6365 31.463,3.96983 30.5,3.5C 20.7209,9.38763 10.7209,14.721 0.5,19.5C 10.5295,12.8315 20.8628,6.49817 31.5,0.5C 33.7263,2.92218 36.0596,2.92218 38.5,0.5C 39.1067,0.62358 39.44,0.956913 39.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e85a6a",
    d: "M 39.5,1.5 C 40.4614,3.26465 40.7947,5.26465 40.5,7.5C 39.7101,8.79423 38.7101,9.9609 37.5,11C 29.628,15.7003 21.628,20.2003 13.5,24.5C 12.7025,24.9569 12.3691,25.6236 12.5,26.5C 12.7955,33.5878 12.4621,40.5878 11.5,47.5C 6.80949,50.7851 3.30949,49.7851 1,44.5C 0.500266,36.1733 0.3336,27.84 0.5,19.5C 10.7209,14.721 20.7209,9.38763 30.5,3.5C 31.463,3.96983 31.463,4.6365 30.5,5.5C 31.1499,5.80393 31.8165,6.13727 32.5,6.5C 35.0765,5.05689 37.4099,3.39022 39.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f6",
    d: "M 30.5,5.5 C 29.5592,7.04953 28.8925,8.7162 28.5,10.5C 21.5,14.5 14.5,18.5 7.5,22.5C 6.29049,22.0679 5.29049,21.4013 4.5,20.5C 12.832,14.9981 21.4986,9.99809 30.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1ed",
    d: "M 18.5,29.5 C 18.6664,37.5069 18.4997,45.5069 18,53.5C 16.6152,52.4495 15.6152,51.1161 15,49.5C 14.5003,42.1742 14.3337,34.8409 14.5,27.5C 23.2185,21.9019 32.2185,17.0686 41.5,13C 40.2101,15.292 38.5435,17.292 36.5,19C 30.2729,22.2743 24.2729,25.7743 18.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#fabe6f",
    d: "M 40.5,7.5 C 44.2062,8.53881 47.8729,8.53881 51.5,7.5C 51.5,9.83333 51.5,12.1667 51.5,14.5C 51.0472,15.4584 50.3805,16.2917 49.5,17C 40.6046,21.941 31.938,27.1077 23.5,32.5C 23.7973,39.9204 23.464,47.2537 22.5,54.5C 21.8333,54.5 21.1667,54.5 20.5,54.5C 20.6664,46.4931 20.4997,38.4931 20,30.5C 19.6174,29.944 19.1174,29.6107 18.5,29.5C 24.2729,25.7743 30.2729,22.2743 36.5,19C 38.5435,17.292 40.2101,15.292 41.5,13C 32.2185,17.0686 23.2185,21.9019 14.5,27.5C 14.1583,26.6618 13.4916,26.3284 12.5,26.5C 12.3691,25.6236 12.7025,24.9569 13.5,24.5C 21.628,20.2003 29.628,15.7003 37.5,11C 38.7101,9.9609 39.7101,8.79423 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7ea6ee",
    d: "M 62.5,14.5 C 59.4274,17.3717 56.0941,19.0383 52.5,19.5C 44.0218,23.3399 35.5218,28.0066 27,33.5C 26.3333,41.5 26.3333,49.5 27,57.5C 27.7172,58.0442 28.2172,58.7109 28.5,59.5C 26.5891,59.4257 25.4224,58.4257 25,56.5C 24.8292,48.3228 24.3292,40.3228 23.5,32.5C 31.938,27.1077 40.6046,21.941 49.5,17C 50.3805,16.2917 51.0472,15.4584 51.5,14.5C 55.1982,15.7721 58.8649,15.7721 62.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#5893fa",
    d: "M 62.5,14.5 C 62.6665,24.1724 62.4998,33.8391 62,43.5C 51.8523,50.156 41.3523,56.156 30.5,61.5C 31.4686,53.2517 31.8019,44.9183 31.5,36.5C 37.3531,32.828 43.3531,29.328 49.5,26C 50.2524,25.3292 50.5858,24.4959 50.5,23.5C 51.1667,22.1667 51.8333,20.8333 52.5,19.5C 56.0941,19.0383 59.4274,17.3717 62.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc91a9",
    d: "M 28.5,10.5 C 28.5858,11.4959 28.2524,12.3292 27.5,13C 20.9375,16.7804 14.2708,20.2804 7.5,23.5C 7.5,23.1667 7.5,22.8333 7.5,22.5C 14.5,18.5 21.5,14.5 28.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3dae4",
    d: "M 4.5,20.5 C 5.29049,21.4013 6.29049,22.0679 7.5,22.5C 7.5,22.8333 7.5,23.1667 7.5,23.5C 7.83083,31.1955 7.49749,38.8622 6.5,46.5C 5.20108,45.91 4.36775,44.91 4,43.5C 3.17767,35.6554 3.34434,27.9887 4.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80b2fe",
    d: "M 50.5,23.5 C 50.5858,24.4959 50.2524,25.3292 49.5,26C 43.3531,29.328 37.3531,32.828 31.5,36.5C 30.8333,36.5 30.1667,36.5 29.5,36.5C 36.2964,31.9302 43.2964,27.5969 50.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.928
    },
    fill: "#f3a84c",
    d: "M 12.5,26.5 C 13.4916,26.3284 14.1583,26.6618 14.5,27.5C 14.3337,34.8409 14.5003,42.1742 15,49.5C 15.6152,51.1161 16.6152,52.4495 18,53.5C 18.4997,45.5069 18.6664,37.5069 18.5,29.5C 19.1174,29.6107 19.6174,29.944 20,30.5C 20.4997,38.4931 20.6664,46.4931 20.5,54.5C 14.8133,56.1845 11.8133,53.8511 11.5,47.5C 12.4621,40.5878 12.7955,33.5878 12.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9edf5",
    d: "M 52.5,19.5 C 51.8333,20.8333 51.1667,22.1667 50.5,23.5C 43.2964,27.5969 36.2964,31.9302 29.5,36.5C 29.8254,44.3516 29.492,52.0182 28.5,59.5C 28.2172,58.7109 27.7172,58.0442 27,57.5C 26.3333,49.5 26.3333,41.5 27,33.5C 35.5218,28.0066 44.0218,23.3399 52.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4963d6",
    d: "M 23.5,32.5 C 24.3292,40.3228 24.8292,48.3228 25,56.5C 25.4224,58.4257 26.5891,59.4257 28.5,59.5C 29.492,52.0182 29.8254,44.3516 29.5,36.5C 30.1667,36.5 30.8333,36.5 31.5,36.5C 31.8019,44.9183 31.4686,53.2517 30.5,61.5C 28.9106,62.6211 27.2439,62.4544 25.5,61C 24.086,59.0065 23.086,56.8398 22.5,54.5C 23.464,47.2537 23.7973,39.9204 23.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3bdf5",
    d: "M 58.5,33.5 C 59.0431,33.56 59.3764,33.8933 59.5,34.5C 58.5,35.3333 57.5,36.1667 56.5,37C 60.4832,36.7247 60.4832,37.7247 56.5,40C 57.7376,39.9227 58.7376,40.0894 59.5,40.5C 57.8816,42.316 55.8816,43.6493 53.5,44.5C 51.5586,42.6841 50.8919,40.6841 51.5,38.5C 54.0765,37.0569 56.4099,35.3902 58.5,33.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.8f7d8864ffd684063ad4c6dc9ac90a11.svg";
export { ForwardRef as ReactComponent };